import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { appStore } from 'src/mobx/appStore';
import { promotionStore } from 'src/mobx/promotionStore';
import MenuBannerList from './MenuBannerList';
import MenuBannerSkeleton from './MenuBannerSkeleton';
import Spinner from 'src/view/components/Controls/Spinner/Spinner';

@observer
export default class MenuBanner extends Component {
  render() {
    if (!promotionStore.banners.length && !promotionStore.loadingBanners && !appStore.settings?.default_image)
      return null;
    if (promotionStore.banners.length) return <MenuBannerList banners={promotionStore.banners} />;
    // Do not show skeleton if banners are cashed
    return <MenuBannerSkeleton />;
  }
}
